import {copilot} from '@cl/shared';
import {CLStore} from 'common/src/redux/store';
import generalAgent from '../agents/generalAgent';
import supportAgent from '../agents/supportAgent';

export default function initializeCopilot(store: CLStore) {
  copilot.registerAgent(generalAgent(store));
  copilot.setSupportAgent(supportAgent(store));
}
